import { protectForm } from './form-turnstile';

class MultistepForm {
  constructor() {
    this.fieldsInit();
    this.formInit();
  }

  formInit = () => {
    const btn = document.querySelector('.js-multistep-form-btn');
    const modal = document.querySelector('.js-multistep-form');
    const exit = document.querySelector('.js-multistep-form-exit');
    btn?.addEventListener('click', (e) => {
      e.preventDefault();
      modal?.classList.add('active');
    });
    exit?.addEventListener('click', () => {
      modal?.classList.remove('active');
    });
  };

  formDataToUrlEncoded = (formData) => {
    const arr = [];

    for (const [key, value] of formData.entries()) {
      arr.push([key, value]);
    }

    const params = new URLSearchParams();
    arr.forEach(([k, v]) => params.append(k, v));
    return params.toString();
  };

  fieldsInit = () => {
    const tabs = document.querySelectorAll('.js-multistep-tab');
    const navigation = document.querySelectorAll('.js-multiform-nav-item');
    const form = document.querySelector('.js-multistep-form form');

    if (!form) {
      return;
    }

    tabs.forEach((tab, tabIndex) => {
      const tabNumber = parseInt(tab.getAttribute('data-tab'));
      const prev = tab.querySelector('.js-multiform-prev');
      const next = tab.querySelector('.js-multiform-next');
      const requiredInputs = tab.querySelectorAll(
        '.js-multiform-input.required'
      );
      prev?.addEventListener('click', () => {
        tabs.forEach((t, index) => {
          t.classList.remove('active');
          if (index == tabNumber - 1) {
            t.classList.add('active');
          }
        });
      });
      next?.addEventListener('click', () => {
        if (requiredInputs.length > 0) {
          const checker = this.checkInputs(requiredInputs);
          if (checker) {
            tabs.forEach((t, index) => {
              t.classList.remove('active');
              if (index == tabNumber + 1) {
                t.classList.add('active');
              }
            });
            navigation[tabIndex + 1].classList.add('js-quiz-done');
          }
        } else {
          tabs.forEach((t, index) => {
            t.classList.remove('active');
            if (index == tabNumber + 1) {
              t.classList.add('active');
            }
          });
          navigation[tabIndex + 1].classList.add('js-quiz-done');
        }
      });
    });
    const protection = protectForm(form);
    let pending = false;
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (pending || !this.checkInputs(form.querySelectorAll('.js-multiform-input.required'))) return;
      pending = true;
      const submit = form.querySelector('[type="submit"]');
      submit.disabled = true;
      form.setAttribute('aria-busy', 'true');
      try {
        const token = await protection.token();
        const id = form.id;
        const formData = new FormData(form);
        const tfaFormData = new FormData(form);
        const endpoint = form.action;
        tfaFormData.delete('_wpcf7_turnstile_response');
        tfaFormData.append('tfa_dbFormId', form.getAttribute('data-tfa-id'));
        tfaFormData.append('tfa_dbControl', form.getAttribute('data-tfa-control'));
        formData.append('_wpcf7_unit_tag', `wpcf7-${id}-123`);
        formData.set('_wpcf7_turnstile_response', token);
        const response = await fetch(`${foodcorps_object.site_url}/wp-json/contact-form-7/v1/contact-forms/${id}/feedback`, {
          method: 'POST',
          body: formData,
        });
        const result = await response.json();
        if (!response.ok || result.status !== 'mail_sent') {
          throw new Error(result.message || 'Unable to send your message. Please try again.');
        }
        // Only submit to FormAssembly after WordPress verifies Turnstile and accepts
        // the contact form. Provider-side spam protection is still required there.
        await fetch('https://foodcorps.tfaforms.net/responses/processor', {
          mode: 'no-cors',
          method: 'POST',
          body: this.formDataToUrlEncoded(tfaFormData),
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        });
        window.location.replace(endpoint);
      } catch (error) {
        protection.showError(error instanceof TypeError ? 'Unable to connect. Please try again.' : error.message);
        protection.reset();
      } finally {
        pending = false;
        submit.disabled = false;
        form.removeAttribute('aria-busy');
      }
    }, true);
  };

  checkInputs = (fields) => {
    let check = true;
    fields.forEach((field) => {
      const input = field.querySelector('input');
      const message = field.querySelector('.js-multiform-required');
      let emailMessage = false;
      if (input.type == 'email') {
        emailMessage = field.querySelector('.js-multiform-email-validate');
      }
      if (!input.value) {
        check = false;
        message.classList.add('active');
      } else if (input.type == 'email') {
        message.classList.remove('active');
        if (!this.validateEmail(input.value)) {
          check = false;
          emailMessage?.classList.add('active');
        } else {
          emailMessage?.classList.remove('active');
        }
      } else {
        message.classList.remove('active');
      }
    });
    return check;
  };
  validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };
}

export default MultistepForm;
new MultistepForm();
